import axios from 'axios'
import { getHeaders } from '@/tools/utils.js'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

const prefix = '/affiliates'

export default {

  async get (id) {
    const headers = await getHeaders()
    return axios.get(prefix + '/' + id, { headers })
  },

  async search (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/search', criterias, { headers })
  },

  async detail (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/detail', criterias, { headers })
  },

  async activate (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/activate', criterias, { headers })
  },

  async inactivate (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/inactivate', criterias, { headers })
  },

  async addProvider (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/addProvider', criterias, { headers })
  },

  async updateProvider (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/updateProvider', criterias, { headers })
  },

  async deleteProvider (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/deleteProvider', criterias, { headers })
  },

  async addMerchant (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/addMerchant', criterias, { headers })
  },

  async updateMerchant (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/updateMerchant', criterias, { headers })
  },

  async deleteMerchant (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/deleteMerchant', criterias, { headers })
  }
}
